import styled from "@emotion/styled";
import { TableBody } from "@material-ui/core";
import { units } from "../../../../types/units";

export const ProductTableBodyStyled = styled(TableBody)`
  ${units({
    backgroundColor: "lighterGrey",
  })};
`;
